<template>
  <validation-provider
    #default="{ errors }"
    name="scope"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Âmbito"
      label-for="scope"
    >
      <v-select
        id="scope"
        v-model="scope"
        :class="errors.length > 0 ? 'error-select' : ''"
        :filter="fuseSearch"
        label="name"
        :options="dataOptions"
        :placeholder="'Âmbito'"
        :disabled="readonly"
        :clearable="!readonly"
        @open="onCreate()"
      >
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #selected-option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #no-options>
          Não há opções de Âmbito.
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import syslic from '@/syslic'
import truncate from '@/components/utils/filters/truncate'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'scopeValue',
    event: 'scopeChange',
  },
  props: {
    scopeValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const dataOptions = []
    const newScopeValue = this.scopeValue

    return {
      dataOptions,
      required,
      newScopeValue,
    }
  },
  computed: {
    scope: {
      get() {
        return this.newScopeValue
      },
      set(value) {
        this.newScopeValue = value
        this.$emit('scopeChange', this.newScopeValue)
      },
    },
  },
  watch: {
    scopeValue(newVal) {
      this.newScopeValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .contract
        .scope
        .fetchScopes()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
